<template>
  <div class="container">
    <h1>Privacy policy</h1>
    <p>
      I dont collect any data. That's it.
    </p>
  </div>
</template>

<script>

export default {
  name: 'privacy',
}
</script>

<style scoped>

</style>